import Session from './session';

const localizeUrl = (path) => {
    let separator = path.indexOf("/") !== 0 ? "/" : "";
    return `/${Session.language+separator+path}`;
}

const createDestinationUrl = (item) => {
    return `/destinations/${item.name}`;
}

const createAccomodationUrl = (item) => {
    
    if(item.type === 'hotel')
        return `/accomodation/hotels/${item.name}`;
    else if(item.type === 'apartments')
        return `/accomodation/apartments/${item.name}`;
    else
        return `/accomodation/${item.name}`;
}

const createTourUrl = (item) => {
    /*if(item.type == 'tour_package')
        return `/tours/tour_packages/${item.name}`;
    else if(item.type == 'excursion')
        return `/tours/excursions/${item.name}`;
    else*/
        return `/tours/${item.name}`;
}

const createExcursionUrl = (item) => {
    return `/excursions/${item.name}`;
}

const createTransferUrl = (item) => {
    return `/transfers/${item.name}`;
}

const createBlogUrl = (item) => {
    return `/blog/${item.name}`;
}

const shuffleArray = (array) => {
    for( let i = array.length -1; i > 0; i--){
        const j = Math.floor(Math.random() * (i +1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

const sortByIndex = (array) => {
    let result =  array.sort(function (a, b) {

        let val1 = a.index ? parseInt(a.index) : Number.MAX_SAFE_INTEGER;
        let val2 = b.index ? parseInt(b.index) : Number.MAX_SAFE_INTEGER;

        if (val1 > val2) {
          return 1;
        }
        if (val1 < val2) {
          return -1;
        }
        return 0;
      })

    return result;
}

const sortByDate = (arr, descending) => {
    let result =  arr.sort( function (a, b) {
                    return new Date(a.date) - new Date(b.date)
                })

    if(descending === true)
        return result.reverse();

    return result;                   
}

const getMaxTouristsNumber = (entityWithPriceRange) => {

    let maxNumber =  entityWithPriceRange.price_ranges ? entityWithPriceRange.price_ranges.map(m => m.number_to).sort( function(a, b) {
        return a - b;
      }).reverse()[0] : 0;

      return maxNumber;
}

const createArrayOfNumbers = (nubmer) => {
    var array = [];
    for (var i = 0; i < nubmer; i++) {
        array.push(i+1);
    }
    return array;
}


const getTranslationForCurrentLang = (translations) => {
    return translations.filter(f => f.lang === Session.language)[0];
}

const getTranslationForProperty = (translations, propertyName) => {
    if(translations.filter(f => f.lang === Session.language)[0] === undefined)
        return 'Not translated';
    else
        return translations.filter(f => f.lang === Session.language)[0][propertyName];
}

const getGroupPriceTranslatedText = (persons) => {
    
    let text = Session.model.common.words.price_for_group2 || 'из';
    let person_singular = Session.model.common.words.person_plural || 'человека';
    let person_plural = Session.model.common.words.person_singular || 'человек';

    //"Стоимость в составе группы из {количество} человек: 1000 руб"
    if(persons == 1 ){
        return `${text} ${persons} ${person_singular}`;
    }

    if(Session.language === 'ru' && (persons % 10) === 1 && persons !== 11){
        return `${text} ${persons} ${person_singular}`;
    }

    return `${text} ${persons} ${person_plural}`;

}

export default {
    locUrl: localizeUrl,
    createDestinationUrl,
    createAccomodationUrl,
    createTourUrl,
    createExcursionUrl,
    createTransferUrl,
    createBlogUrl,
    shuffleArray,
    sortByIndex,
    sortByDate,
    getMaxTouristsNumber,
    createArrayOfNumbers,
    getTranslationForCurrentLang,
    getTranslationForProperty,
    getGroupPriceTranslatedText
};
